<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-format-list-checks" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Validação de Atributos MCPSE</div>
      </template>

      <v-btn
        id="btn-nova-validacao-mcpse"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="adicionarValidacao()"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Nova Validação
      </v-btn>

      <v-text-field
        id="validacao-mcpse-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-validacao-mcpse ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars class="mt-11" :items="downloadProgressData" prefixText="Baixando Validação" />

      <v-divider class="mt-10" />

      <v-data-table
        class="validacao-mcpse-table"
        :headers="headers"
        :items="validacoes"
        :search.sync="search"
        :headerProps="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhuma validação de atributos MCPSE disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.base`]="{ item }">
          {{ item.base }}
        </template>
        <template v-slot:[`item.executed`]="{ item }">
          {{ item.executed }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-validacao-mcpse"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            color="gray"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="baixarValidacao(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-menu v-if="canRunItem(item) || canDeleteItem(item)" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-validacao-mcpse"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarValidacao(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDeleteDialog(item)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :showDialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarValidacao(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Validação #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a Validação
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes Validação de Atributos MCPSE"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="[
            { text: 'Parâmetro', value: 'parametro', sortable: false },
            { text: 'Valor', value: 'valor', sortable: false }
          ]"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td
                v-if="'arquivo_id' in row.item"
                class="download-arquivo-detalhes-click"
                @click="downloadArquivoById(row.item.arquivo_id, row.item.arquivo_nome)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-progress-circular v-if="loadingDownloadArquivoById" indeterminate color="primary" size="20" />
                      <span v-else>{{ row.item.arquivo_nome }}</span>
                    </div>
                  </template>
                  <span v-if="loadingDownloadArquivoById">AGUARDE :: Baixando arquivo [{{ row.item.arquivo_nome }}]...</span>
                  <span v-else>Clique aqui para baixar o arquivo</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
  import ValidacaoService from '@/services/ValidacaoAtributosMcpseService.js';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins, pusherMixins, tourMixins],

    data() {
      return {
        dialogDelete: false,
        dialogDeleteData: { id: undefined, nome: undefined },
        search: '',
        loading: false,
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Base',
            value: 'base'
          },
          {
            text: 'Executado',
            value: 'executed'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ],
        validacoes: [],
        downloadProgressData: {},
        arrTour: [
          {
            element: '#btn-nova-validacao-mcpse',
            intro: 'Clicando neste botão você poderá criar novas validações de atributos MCPSE.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#validacao-mcpse-historico-search',
            intro: 'Neste campo você poderá pesquisar por validações de atributos MCPSE já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-validacao-mcpse',
            intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua validação de atributos MCPSE.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-validacao-mcpse',
            intro:
              'Aqui você acessa outras opções para sua validação de atributos MCPSE, como executá-la novamente ou deletá-la.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    mounted() {
      this.subscribe();
      this.getValidacoes();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-validacao-atributos-mcpse', () => {
          this.getValidacoes();
        });
      },

      getValidacoes() {
        this.loading = true;
        ValidacaoService.getValidacoes()
          .then((response) => {
            this.validacoes = [];

            response.data.validacoes.forEach((val) => {
              this.validacoes.push({
                id: val.id,
                nome: val.titulo,
                usuario: val.usuario.nome,
                usuario_id: val.usuario.id,
                base: val.tipo == 'BASE CONTABIL' ? 'CONTÁBIL' : 'FÍSICA',
                executed: val.data_processamento ? dayjs(val.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
                status: val.status,
                arquivo_validacao: val.arquivo
                  ? {
                      arquivo: val.arquivo.arquivo,
                      id: val.arquivo.id
                    }
                  : null
              });
            });
          })
          .finally(() => {
            this.loading = false;
            this.iniciarTourPagina();
          });
      },

      adicionarValidacao() {
        this.$router.push('edit');
      },

      openDeleteDialog(validacao) {
        this.dialogDeleteData = {
          id: validacao.id,
          nome: validacao.nome
        };

        this.dialogDelete = true;
      },

      deletarValidacao(id) {
        this.dialogDelete = false;

        ValidacaoService.excluirValidacao(id)
          .then(() => {
            this.getValidacoes();
            this.$toast.success('Validação excluída com sucesso.', '', { position: 'topRight' });
          })
          .catch((err) => {
            this.$toast.error('Erro ao excluir Validação.', '', { position: 'topRight' });
            console.log('Erro: ', err);
          });
      },

      executarValidacao(id) {
        ValidacaoService.executarValidacao(id)
          .then(() => {
            this.$toast.info('Sua planilha será gerada em instantes. Por favor, aguarde.', '', {
              position: 'topRight',
              timeout: 2000
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao executar Validação.', '', { position: 'topRight' });
            console.log('Erro: ', err);
          })
          .finally(() => {
            this.getValidacoes();
          });
      },

      baixarValidacao(validacao) {
        const id = validacao.id;
        const nomeValidacao = `Resultado_Validação_de_Atributos_MCPSE_${id}__${validacao.nome}.xlsx`;

        this.$set(this.downloadProgressData, id, { id });
        this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 2000 });

        ValidacaoService.baixarValidacao(validacao.id, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;

            this.$set(this.downloadProgressData, id, { progress, isComputable, id });
          }
        })
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeValidacao);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Falha no download do resultado.', '', { position: 'topRight' });
            console.log('Erro: ', err);
          })
          .finally(() => {
            this.$delete(this.downloadProgressData, id);
          });
      },

      openDialogDetalhes(item) {
        this.dialogDetalhesData = [];

        if (item.arquivo_validacao) {
          this.dialogDetalhesData.push({
            parametro: 'ARQUIVO VALIDAÇÃO:',
            arquivo_nome: item.arquivo_validacao.arquivo,
            arquivo_id: item.arquivo_validacao.id
          });
        }

        this.dialogDetalhes = true;
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.validacoes.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .validacao-mcpse-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .validacao-mcpse-table table tr td:nth-child(6),
    .validacao-mcpse-table table tr td:nth-child(7) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-validacao-mcpse {
      width: 195.19px !important;
    }
  }
</style>